import axios from 'axios'
import { debounce } from 'lodash'

const state = {
  professionals: []
}

const actions = {
  searchProfessionals: debounce(async ({ commit }, keyword) => {
    const url = `/beneat/professionals?keywords=${keyword}`
    const { data } = await axios.get(url)
    if (data.professionals) {
      commit('SET_PROFESSIONALS', data.professionals)
    }
  }, 500)
}

const mutations = {
  SET_PROFESSIONALS: (state, professionals) => {
    state.professionals = professionals
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
